<template>
  <div>
    <span
      class="q-pa-sm hover-active block cursor-pointer"
      outline
      @click="open"
    >
      <span class="bold">{{ $t("global.media_types") }}</span>
      {{ selectedMediaTypesLabel }}
    </span>

    <QDialog
      v-model="show"
      position="bottom"
      square
    >
      <QCard class="full-width">
        <QCardSection class="header row q-pa-md justify-between">
          <QBtn
            dense
            flat
            :label="$t('universal_search_actionsheet_select_media_types.back')"
            size="12px"
            @click="close"
          />
          <span class="title bold block">{{ $t("global.media_types") }}</span>
          <QBtn
            dense
            flat
            :label="$t('universal_search_actionsheet_select_media_types.done')"
            size="12px"
            @click="saveAndClose"
          />
        </QCardSection>

        <div class="q-pa-md">
          <UniversalSearchMediaTypeFilter
            v-model="localStream"
            :excluded-media="excludedMedia"
          />
        </div>
      </QCard>
    </QDialog>
  </div>
</template>

<script>
import { getMediaForStream, getSources } from "shared/helpers/media";

import UniversalSearchMediaTypeFilter from "./UniversalSearchMediaTypeFilter.vue";

export default {
  name: "UniversalSearchActionsheetSelectMediaTypes",
  components: {
    UniversalSearchMediaTypeFilter,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    excludedMedia: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      show: false,
      sources: getSources(),
      localStream: { ...this.modelValue },
    };
  },
  computed: {
    selectedMediaTypes() {
      return getMediaForStream(this.localStream);
    },
    selectedMediaTypesLabel() {
      if (!this.selectedMediaTypes.length) return "";

      const selectedMediaTypesLength = this.selectedMediaTypes.filter(
        (medium) => !this.excludedMedia.includes(medium)
      ).length;

      const selectedSourcesLength = this.sources.filter(
        ({ medium }) => !this.excludedMedia.includes(medium)
      ).length;

      return `(${selectedMediaTypesLength}/${selectedSourcesLength})`;
    },
  },
  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.localStream = { ...this.modelValue };
      },
    },
  },
  methods: {
    open() {
      this.localStream = { ...this.modelValue };
      this.show = true;
    },
    close() {
      this.show = false;
    },
    saveAndClose() {
      this.$emit("update:modelValue", this.localStream);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 1px solid #ddd;
}

.title {
  font-size: 19px;
}
</style>
